/*
 * ====================================================================
 * Grow Template
 * @package  Grow Template
 * @author   GrowGroup.Inc <info@grow-group.jp>
 * @license  MIT Licence
 * ====================================================================
 */

(function ($) {
  var growApp = function () {

  };

  /************************
   * please insert your code
   *************************/
  growApp.prototype.changeMenuButton = function () {
    var mainVisual = $('.c-main-visual');
    var menuButton = $('.c-slidebar-button');
    if (mainVisual.length === 0) {
      return false;
    }
    menuButton.addClass('is-top');
  };

  // トップページパララックス
  growApp.prototype.bgParallax = function () {
    var el = $('.js-parallax');
    if (el.length === 0) {
      return false;
    }

    $(window).on('scroll', function () {
      var targetPosition = el.offset().top;
      var scrollTop = $(window).scrollTop();
      var windowHeight = $(window).innerHeight();
      var startAnimPos = scrollTop + windowHeight;
      var offsetY = (startAnimPos - targetPosition) / 10;

      var scrollParallax = function () {
        el.each(function (index, element) {
          targetPosition = $(element).offset().top;
          offsetY = (startAnimPos - targetPosition) / 10;
          $(element).css('background-position', $(element).data('background-position') + ' -' + offsetY + 'px');
        });
      };

      if (offsetY) {
        if (startAnimPos >= targetPosition) {
          scrollParallax();
        }
      }

    });
  };


  // エンターアニメーション
  growApp.prototype.enterAnim = function () {
    // 1. 真っ白な画面
    // 2. ロゴが真ん中にふわっと表示される
    // 3. コピーが先にすんっと非表示になる
    // 4. ロゴマークがゆっくり非表示になる
    // 5. 真っ白な画面もフェードアウトする
    // 6. メインビジュアルの画像が表示される
    // 7. 白い丸（ロゴとメニューも含む）が順番にふわっと表示される
    // 8. キャッチコピーが先にスライドインする
    // 9. キャッチコピーの下の小さい文字も続いてスライドインする

    //DOM
    var $loader = document.querySelector(".c-loader");
    if (!$loader) {
      return false;
    }
    var $body = document.querySelector("body");
    var $header = document.querySelector(".l-header-minimal");
    var $slideButton = document.querySelector(".c-slidebar-button");
    var $mainvisual = document.querySelector(".c-main-visual");

    //コンストラクタ
    function changeClass(el, className, time) {
      //Promiseを使用
      return new Promise(function (resolve, reject) {
        setTimeout(function () {
          el.classList.add(className);
          //resolve処理が成功したら
          resolve(className);
        }, time);
      });
    }

    if (localStorage.getItem('visited')) {
      changeClass($loader, "is-finished", 1).then(function () {
        changeClass($mainvisual, "is-trigger-01", 1000).then(function () {
          $header.classList.add("is-finished");
          $slideButton.classList.add("is-finished");
          changeClass($mainvisual, "is-trigger-02", 1000).then(function () {

          });
        });
      });
      return false;
    }
    localStorage.setItem('visited', true);


    var loadAnim = function () {
      changeClass($loader, "is-trigger-01", 800).then(function () {
        changeClass($loader, "is-trigger-02", 1500).then(function () {
          changeClass($loader, "is-finished", 1800).then(function () {
            changeClass($mainvisual, "is-trigger-01", 1000).then(function () {
              $header.classList.add("is-finished");
              $slideButton.classList.add("is-finished");
              changeClass($mainvisual, "is-trigger-02", 1000).then(function () {

              });
            });
          });
        });
      });
    };

    if ($loader) {
      loadAnim();
    }
  };


  $(function () {
    var app = new growApp();
    app.changeMenuButton();
    app.bgParallax();
    app.enterAnim();
  });
})(jQuery);
